<template>
  <div class="flex items-center flex-wrap gap-x-8 gap-y-4">
    <BittsAvatarItem
      v-for="userAccess in users"
      :key="userAccess.user_id"
      :user="userAccess.user as User"
      :show-initials="true"
      size="small"
      spacing="condensed"
      :title="
        userAccess.user?.first_name && userAccess.user?.last_name
          ? `${userAccess.user.first_name} ${userAccess.user.last_name}`
          : 'User'
      "
      class="report-access-cell__user-avatar"
      :has-dark-bg="true"
    />
  </div>
</template>

<script setup lang="ts">
import { BittsAvatarItem } from '@crossbeam/bitts';

import { ReportUserAccess } from '@/types/reports';
import { User } from '@/types/root';

defineProps<{ users: ReportUserAccess[] }>();
</script>
